import React from 'react';
import { ReactCompareSlider, ReactCompareSliderImage } from 'react-compare-slider';

import Typography from '../common/typography/Typography';
import { Container, TextContainer } from '../../styles/ComparisonSliderStyles';

import useLanguagePack from '../../hooks/useLanguagePack';
const Polygon = () => (
  <div>
    {/* <svg width='52' height='26' viewBox='0 0 52 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M25.5477 0L51.0955 25.5H0L25.5477 0Z' fill='#939393' />
    </svg> */}
    <img src='/assets/image/newLanding/slide_polygon.png' />
  </div>
);

const CustomHandle = () => {
  const languageKeyStrings = { sliderText: useLanguagePack('landing_contents2_coachmark_slide_1') };
  return (
    <TextContainer>
      <div className='resizer' />
      <div className='guide-text'>
        <Polygon />
        <Typography variant={'C3'}>{languageKeyStrings.sliderText}</Typography>
      </div>
    </TextContainer>
  );
};

const ComparisonSlider = () => {
  return (
    <Container>
      <ReactCompareSlider
        handle={<CustomHandle />}
        itemOne={<ReactCompareSliderImage src={'/assets/image/main_before.jpg'} srcSet={'/assets/image/main_before.jpg'} alt='Before' />}
        itemTwo={<ReactCompareSliderImage src={'/assets/image/main_after.jpg'} srcSet={'/assets/image/main_after.jpg'} alt='After' />}
        style={{ width: '690px', height: '360px' }}
      />
    </Container>
  );
};

export default ComparisonSlider;
